import { Link } from "react-router-dom";
import { ArrowLeft, CheckCircle } from "@phosphor-icons/react";
import BrandLockup from "@/components/BrandLockup";
import PublicThemeControl from "@/components/PublicThemeControl";

export default function PublicDemoNav({ selectionMode = false }) {
  const resetWebsiteScroll = () => {
    if (typeof window === "undefined") return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  };

  return (
    <>
      <header className={`public-demo-header public-demo-header--desktop relative z-30 border-b px-5 py-4 backdrop-blur-xl sm:px-8${selectionMode ? " public-demo-header--selection" : ""}`}>
        <div className="public-demo-header__inner mx-auto flex max-w-7xl items-center justify-between">
          <div className="public-demo-header__brand-group">
            <Link to="/" onClick={resetWebsiteScroll} className="brand-lockup-link" aria-label="Back to Callsect website">
              <BrandLockup className="brand-lockup--landing" variant="auto" />
            </Link>
            <span className="public-demo-header__synthetic">Interactive demo</span>
          </div>

          <div className="public-demo-header__actions">
            <PublicThemeControl />
            <Link to="/" onClick={resetWebsiteScroll} className="public-demo-header__back" aria-label="Back to homepage">
              <ArrowLeft size={14} weight="bold" aria-hidden="true" />
              <span>Back to homepage</span>
            </Link>
          </div>
        </div>
      </header>

      {!selectionMode && (
        <header className="public-demo-mobile-legacy-nav relative z-30 border-b border-white/[0.06] bg-[#050507]/80 px-5 py-4 backdrop-blur-xl" aria-label="Callsect interactive demo">
          <div className="mx-auto flex max-w-7xl items-center justify-between">
            <Link to="/" onClick={resetWebsiteScroll} className="brand-lockup-link" aria-label="Back to Callsect website">
              <BrandLockup className="brand-lockup--mobile-nav" variant="dark" />
            </Link>
            <div className="demo-mobile-status">
              <CheckCircle size={15} weight="fill" aria-hidden="true" />
              Interactive demo
            </div>
            <Link to="/" onClick={resetWebsiteScroll} className="demo-mobile-exit" aria-label="Exit interactive demo">
              <ArrowLeft size={17} weight="bold" aria-hidden="true" />
              <span>Exit</span>
            </Link>
          </div>
        </header>
      )}
    </>
  );
}
